module.exports = __webpack_public_path__ + "img/cu.177dfd45.svg";